import { Dispatch, SetStateAction } from 'react'
import { IAddressSuggestion } from 'interfaces/application'
import HouseApplicationStore from 'stores/houseApplicationStore'
import { getValidArray } from 'utils/common'
import { IAddressOption } from '.'

function getOptions(addressList: IAddressSuggestion[]): IAddressOption[] {
  const addressOptions: IAddressOption[] = getValidArray(addressList).map((addressSuggestion: IAddressSuggestion) => ({
    value: addressSuggestion?.id,
    label: addressSuggestion?.fullAddress,
    ...addressSuggestion
  }))
  return addressOptions
}

export async function handleChangeAddress(
  closeDropDown: () => void,
  setIsLoading: Dispatch<SetStateAction<boolean>>,
  houseApplicationStore: HouseApplicationStore,
  address: string,
  newSessionToken: string,
  setDefaultOptions: Dispatch<SetStateAction<IAddressOption[]>>,
  openDropDown: () => void
): Promise<void> {
  closeDropDown()
  setIsLoading(true)
  const result: IAddressSuggestion[] = await houseApplicationStore.getMapboxAddress({
    address,
    sessionToken: newSessionToken
  })
  const addressOption: IAddressOption[] = getOptions(result)

  if (addressOption.length > 0) {
    setDefaultOptions(addressOption)
    openDropDown()
    setIsLoading(false)
  }
}
